import { GET_ALL_TEMPLATE } from "../../constant/ActionType";

export default function AllgetTemplates(
  state = {
    templatesGet: [],
  },
  action
) {
  switch (action.type) {

    case GET_ALL_TEMPLATE:
        console.log(action?.data)
      return {
        ...state,
        templatesGet: action?.data?.data,
      };

    default:
  }

  return state;
}
